// Main application layout - 40 lines ✅
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { ErrorBoundary } from './ErrorBoundary'

export function AppLayout(): JSX.Element {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const handleMenuClick = (): void => {
    setIsSidebarOpen((prev) => !prev)
  }

  const handleSidebarClose = (): void => {
    setIsSidebarOpen(false)
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Header onMenuClick={handleMenuClick} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar isOpen={isSidebarOpen} onClose={handleSidebarClose} />
        <main className="flex-1 overflow-y-auto">
          <div className="container py-6">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
        </main>
      </div>
    </div>
  )
}
